import styled from 'styled-components';

export const WrapperCart = styled.aside`
  font-family: Arial, Helvetica, sans-serif;
  width: 400px;
  padding: 20px;
`;
